import { render, staticRenderFns } from "./CFRubricImportModal.vue?vue&type=template&id=6b518b7d&scoped=true"
import script from "./CFRubricImportModal.vue?vue&type=script&lang=js"
export * from "./CFRubricImportModal.vue?vue&type=script&lang=js"
import style0 from "./CFRubricImportModal.vue?vue&type=style&index=0&id=6b518b7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b518b7d",
  null
  
)

export default component.exports